import React from 'react';
import AssetTypeCard from './Assettypecard';
import { EquipmentI, EquipmentSimpleI } from '@interfaces';
import { useNavigate } from 'react-router-dom';

interface AssetTypesGridProps {
  assetsByType:any[];
}
const AssetTypesGrid = ({ assetsByType }:AssetTypesGridProps) => {
  const navigate = useNavigate();
  return (
    <div className="asset-types-section">
      <div className="section-header">
        <h2>Tipos de Activos</h2>
        <button className="view-all-btn" onClick={()=>navigate("/equipments/list")}>
          Ver Todos
          <span>→</span>
        </button>
      </div>

      <div className="asset-types-grid">
        {assetsByType?.map((assetType:any, index:any) => (
          <AssetTypeCard key={index} {...assetType} />
        ))}
      </div>
    </div>
  );
};

export default AssetTypesGrid;